import React from 'react';
import { Step } from 'react-joyride';
import BaseTour from './BaseTour';
import { useTranslation } from 'react-i18next';

interface EmotionalSpendingTourProps {
    isRunning: boolean;
    onComplete: () => void;
}

const EmotionalSpendingTour: React.FC<EmotionalSpendingTourProps> = ({ isRunning, onComplete }) => {
    const { t } = useTranslation();
    
    const steps: Step[] = [
        {
            target: 'body',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.emotional_spending.welcome.title')}
                    </h3>
                    <p>{t('app_tour.emotional_spending.welcome.description')}</p>
                </div>
            ),
            placement: 'center',
            disableBeacon: true,
        },
        {
            target: '[data-tour="log-purchase-form"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.emotional_spending.log_purchase_form.title')}
                    </h3>
                    <p>{t('app_tour.emotional_spending.log_purchase_form.description')}</p>
                </div>
            ),
            placement: 'right',
            spotlightClicks: false,
        },
        {
            target: '[data-tour="recent-records"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.emotional_spending.recent_records.title')}
                    </h3>
                    <p>{t('app_tour.emotional_spending.recent_records.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="spending-by-emotion"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.emotional_spending.spending_by_emotion.title')}
                    </h3>
                    <p>{t('app_tour.emotional_spending.spending_by_emotion.description')}</p>
                </div>
            ),
            placement: 'right',
        },
        {
            target: '[data-tour="alternative-actions"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.emotional_spending.alternative_actions.title')}
                    </h3>
                    <p>{t('app_tour.emotional_spending.alternative_actions.description')}</p>
                </div>
            ),
            placement: 'left',
        },
        {
            target: '[data-tour="emotional-spending-table"]',
            content: (
                <div>
                    <h3 style={{ marginBottom: '12px', fontSize: '18px', fontWeight: '600' }}>
                        {t('app_tour.emotional_spending.complete_records_table.title')}
                    </h3>
                    <p>{t('app_tour.emotional_spending.complete_records_table.description')}</p>
                </div>
            ),
            placement: 'top',
        },
    ];

    return <BaseTour isRunning={isRunning} onComplete={onComplete} tourId="emotional-spending" steps={steps} navigateTo="/dashboard/tools/emotional-spending" />;
};

export default EmotionalSpendingTour;

